<template>
  <div class="ticket">
    <div class="right-container">
      <p style="margin-top: 1rem; font-size: 0.6125rem">core-event.co</p>
      <canvas ref="qrcode" class="qrcode" :style="{ margin: 0, padding: 0 }" />
    </div>
    <div class="left-container">
      <h1 class="event-name" :style="eventInfo.eventTitle.length > 30 && 'font-size: 18px'">
        {{ eventInfo.eventTitle }}
      </h1>
      <div class="content">
        <div class="content-group">
          <p>Datum: {{ formatDate(eventInfo.from) }}</p>
          <p>dvorana {{ eventInfo.venue }}</p>
        </div>
        <div class="content-group">
          <p v-if="ticketInfo.accreditation.ticketLocation">
            Sektor:
            <span style="font-weight: 800; font-size: 20px">{{ getTicketRow('section') }}</span>
          </p>
          <p v-if="ticketInfo.accreditation.ticketLocation">
            Red:<span style="margin-right: 1rem; font-weight: 800; font-size: 20px">{{
              getTicketRow('row')
            }}</span>
            Sjedalo:<span style="font-weight: 800; font-size: 20px">{{
              getTicketRow('seat')
            }}</span>
          </p>
          <p style="font-weight: 800; font-size: 20px">
            {{ ticketInfo.orderItem.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import moment from 'moment/moment'

export default {
  name: 'zf-ticket-seller-pdf',
  props: {
    eventInfo: Object,
    organization: Object,
    ticketInfo: Object,
    index: Number,
    ticketCount: Number,
  },
  data() {
    return {
      totalPriceRounded: null,
    }
  },
  async mounted() {
    console.log(this.eventInfo)
    this.generateQrCode(this.fiscalisationInfo)
    this.loading = false
  },
  methods: {
    async generateQrCode() {
      const canvas = this.$refs.qrcode

      return QRCode.toDataURL(canvas, this.ticketInfo.accreditation.qrcode.toString(), {
        width: 75,
        margin: 0,
      })
    },
    getTicketRow(searchingTerm) {
      return this.ticketInfo.accreditation.ticketLocation
        .toLowerCase()
        .split('_')
        .filter(loc => loc.includes(searchingTerm))[0]
        .split('-')[1]
    },
    formatDate(date) {
      return moment(date).tz('Europe/Zagreb').format('DD.MM.YYYY. [Sat]: HH:mm')
    },
  },
}
</script>

<style scoped>
.ticket {
  font-family: 'Monument Grotesk', monospace;
  justify-content: end;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 2rem 0rem 3rem 3rem;
}

.right-container {
  width: 100%;
  height: 100%;
  display: flex;
  transform: rotate(-90deg);
  align-items: center;
  flex-direction: column-reverse;
}

p,
h1 {
  margin-bottom: 0.5rem;
}

.left-container {
  transform: rotate(-90deg);
  padding-left: -10.5rem;
  padding-bottom: 8.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 400px;
}

.content {
  flex-direction: column;
  display: flex;
  overflow: hidden;
  height: 156px !important;
  width: 300px !important;
}

.content-group {
  display: flex;
  flex-direction: column;
}

.content-group p {
  color: #333;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 108%;
}

.event-name {
  color: #333;
  font-size: 20px;
  font-weight: 700;
  line-height: 108%;
  width: 400px;
}
</style>
